import React, { Component } from 'react';
import PropTypes from 'prop-types';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

import UploadButton from './UploadButton';

import CONSTANTS from '../utils/Constants';

const StyledAppBar = styled(AppBar)(({ theme, category }) => ({
	top: 'auto',
	bottom: 0,
	backgroundColor: category === 'positive' ? CONSTANTS.COLORS.POSITIVE :
					 category === 'uncertain' ? CONSTANTS.COLORS.UNCERTAIN :
					 category === 'negative' ? CONSTANTS.COLORS.NEGATIVE :
					 category === 'tip' ? CONSTANTS.COLORS.TIP :
					 theme.palette.background.default,
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
	minHeight: theme.spacing(9),
	paddingLeft: theme.spacing(3.5),
	paddingRight: theme.spacing(3.5)
}));

const GrowDiv = styled('div')({
	flex: 1
});

const StyledButton = styled(Button)(({ theme, category }) => ({
	'&.MuiButton-containedPrimary': {
		backgroundColor: category === 'positive' ? CONSTANTS.COLORS.POSITIVE :
						 category === 'uncertain' ? CONSTANTS.COLORS.UNCERTAIN :
						 category === 'negative' ? CONSTANTS.COLORS.NEGATIVE :
						 category === 'tip' ? CONSTANTS.COLORS.TIP :
						 theme.palette.primary.main,
	}
}));

class FormFooter extends Component {
	constructor(props) {
		super(props);
		this.emergencyBtn = props.category === "negative" && React.createRef();
	}

	componentDidMount() {
		const simulateClick = el => {
			const event = new MouseEvent('click', {
				bubbles: true,
				cancelable: true,
				view: window
			});
			el.dispatchEvent(event);
		}
		if(this.emergencyBtn && window.location.search === "?call") {
			simulateClick(this.emergencyBtn.current);
		}
	}

	render() {
		let {category, selectFileHandler, attachedCount, disableSubmit} = this.props;
		let emergencyBtn = null;
		let trackerLabel = `Send ${category} Submission`;

		return (
			<StyledAppBar position="fixed" category={category} elevation={2} square>
				<StyledToolbar>
					{emergencyBtn}
					<UploadButton selectFileHandler={selectFileHandler} count={attachedCount} />
					<GrowDiv />
					<StyledButton
						ga-on="click"
						ga-event-category="WebApp"
						ga-event-action="Button Pressed"
						ga-event-label={trackerLabel}
						disabled={disableSubmit}
						variant="contained"
						color="primary"
						aria-label="send"
						type="submit"
						category={category}
					>
						Send
					</StyledButton>
				</StyledToolbar>
			</StyledAppBar>
		);
	}
}

FormFooter.propTypes = {
	selectFileHandler: PropTypes.func.isRequired,
	attachedCount: PropTypes.number,
	disableSubmit: PropTypes.bool,
	category: PropTypes.string.isRequired
};

export default FormFooter;